const STORAGE_PREFIX = 'spotlight:seen:';

const key = (id: string) => `${STORAGE_PREFIX}${id}`;

export const isSpotlightSeen = (id: string): boolean => {
  try {
    return localStorage.getItem(key(id)) === '1';
  } catch {
    return false;
  }
};

export const markSpotlightSeen = (id: string): void => {
  try {
    localStorage.setItem(key(id), '1');
  } catch {
    /* storage unavailable — accept replay until the page reloads */
  }
};

export const clearSpotlightSeen = (id: string): void => {
  try {
    localStorage.removeItem(key(id));
  } catch {
    /* noop */
  }
};
